export default __webpack_public_path__ + "ed3a9f3b29d66984b64f16a5868ed369.png";